import { apiFetch } from '@/lib/api';
import type { ProviderInfo, TranslateJob, StartTranslateBatchInput } from '@/types/translateJob';

export async function listProviders(): Promise<ProviderInfo[]> {
  return apiFetch<ProviderInfo[]>('/translate-batch/providers');
}

export async function startBatch(
  input: StartTranslateBatchInput,
): Promise<{ job_id: string; status: 'queued' }> {
  return apiFetch<{ job_id: string; status: 'queued' }>('/translate-batch', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function getJob(jobId: string): Promise<TranslateJob> {
  return apiFetch<TranslateJob>(`/translate-batch/${encodeURIComponent(jobId)}`);
}
